module.exports = __webpack_public_path__ + "static/media/img-aa844fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/goodwill-logo.png
// module id = 5286
// module chunks = 39